/**
 * Created by Andrey Popov on 2/3/26.
 */

RewardsConfig.AdventurePack = {
    energy: 250
};

RewardsConfig.AdventureCheapPack = [
    { energy: 150 },
    { energy: 500 },
    { energy: 500 },
    { energy: 1250 },
    { energy: 1250 }
];

RewardsConfig.AdventureExpPack = [
    { energy: 500 },
    { energy: 1250 },
    { energy: 1250 },
    { energy: 5500, hard: 2000 },
    { energy: 5500, hard: 2000 }
];